export const smartDevicePopupLink = {
    blade: 'https://www.facebook.com/groups/ecoflowblade?utm_source=Web&utm_medium=officialwebsite&utm_campaign=smartdevices',
    glacierWave: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    de: 'https://www.facebook.com/groups/ecoflowclubdeutsch?utm_source=Web&utm_medium=officialwebsite&utm_campaign=smartdevices',
    fr: 'https://www.facebook.com/groups/ecoflowfrancophone?utm_source=Web&utm_medium=officialwebsite&utm_campaign=smartdevices',
    jp: 'https://lin.ee/g7W0VbD',
};
